

















































































































import Vue from "vue";
import { mapState } from "vuex";
import { RootState } from "@/store";
import { LOGOUT } from "@/store/modules/AuthenticationModule/actions";
import * as m from "@/store/modules/ApplicationModule/mutations";
import * as routes from "@/router/routes";
import ChangePasswordCard from "./ChangePasswordCard.vue";
import Notifications from "./Notifications.vue";

export default Vue.extend({
    components: {
        ChangePasswordCard,
        Notifications,
    },
    props: {
        loomisStyle: Boolean,
    },
    data() {
        return {
            dialog: null,
            routes,
        };
    },
    computed: {
        ...mapState({
            authUser: (state: RootState) => state.authMod.currentUser,
            azureUserDisplayName: (state: RootState) => state.authMod.azureDisplayName,
        }),
        isAzureUser() {
            return this.authUser.isWindowsLogin && this.azureUserDisplayName != null;
        },
        drawer: {
            get() {
                return this.$store.state.application.drawer;
            },
            set(value) {
                this.$store.commit(m.SET_DRAWER, value);
            },
        },
    },
    methods: {
        changePasswordClick() {
            this.dialog = true;
        },
        doLogout() {
            this.$store.dispatch(LOGOUT);
        },
    },
});
